import { useNavigate } from 'react-router';

import warningIcon from '../../../assets/images/warningIcon.svg';
import { getAllOrdersThunk } from '../../../store/slices/allOrdersSlice';
import { cancelAsnThunk } from '../../../store/slices/asnSlice';
import { updateOrderThunk } from '../../../store/slices/ordersSlice';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import OutlineButton from '../../ui/buttons/outlineButton/OutlineButton';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function CancelOrderPopup() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // получаем номер заказа из sessionStorage
  const orderCard = JSON.parse(sessionStorage.getItem('order'));
  const orderNumber = orderCard?.number || '';
  const hasPickedStatus = orderCard?.status === 'Собран';
  console.log(orderCard, 'from canselOrderPopup');

  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  const onCancelExecute = () => {
    if (orderCard?.type === 'order') {
      const payload = {
        ...orderCard,
        cancel_reason: 'Отменено пользователем',
        pass: {
          carNum: orderCard?.carNum || '',
          name: orderCard?.name || '',
        },
        grms: orderCard.items.map((item) => item.grm),
        order_no: orderCard.number,
      };

      dispatch(updateOrderThunk(payload))
        .unwrap()
        .then(() => {
          dispatch(
            getAllOrdersThunk({
              status_array: [
                'CREATED',
                'PROCESSING',
                'CONFIRMED',
                'PACKED',
                'DELIVERY',
                'ACCEPTED',
              ],
            })
          );
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      dispatch(
        cancelAsnThunk({
          ...orderCard,
          cancel_reason: 'Отменено пользователем',
          pass: {
            carNum: orderCard?.carNum || '',
            name: orderCard?.name || '',
          },
          asn_no: orderCard.number,
        })
      )
        .unwrap()
        .then(() => {
          dispatch(
            getAllOrdersThunk({
              status_array: [
                'CREATED',
                'PROCESSING',
                'CONFIRMED',
                'PACKED',
                'DELIVERY',
                'ACCEPTED',
              ],
            })
          );
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleNavigate = () => {
    dispatch(closePopup());
    sessionStorage.removeItem('order');
    navigate('/orders');
  };

  const handleConfirm = () => {
    if (orderCard) {
      dispatch(closePopup());
      onCancelExecute();
      handleNavigate();
    } else {
      handleNavigate();
    }
  };

  return (
    <div className={styles.cancelOrderPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.cancelOrderTextWrapper}>
        <img src={warningIcon} alt="иконка предупреждение" />
        <h2 className={styles.cancelOrderTitle}>
          Вы уверены что хотите отменить заказ № {orderNumber}?
        </h2>
        <h3 className={styles.cancelOrderSubTitle}>
          После отмены заказа восстановить заказ будет не возможно
        </h3>
        {hasPickedStatus && (
          <p className={styles.cancelOrderText}>
            Обратите внимание!
            <br />
            На данном этапе отмена заказа будет платной. Расчёт услуги вы сможете
            посмотреть в разделе «Баланс и оплата»
          </p>
        )}
      </div>
      <div className={styles.cancelOrderPopupButtons}>
        <OutlineButton text="Нет" onClick={handleClosePopup} width={148} height={50} />
        <RedButton text="Да" onClick={handleConfirm} width={148} height={50} />
      </div>
    </div>
  );
}

export default CancelOrderPopup;
